module.exports = __webpack_public_path__ + "static/media/26-nysgjerrig.409041d0.mp3";